// ** Routes Imports
import AppRoutes from './Apps'
import FormRoutes from './Forms'
import PagesRoutes from './Pages'
import TablesRoutes from './Tables'
import ChartsRoutes from './Charts'
import DashboardRoutes from './Dashboards'
import UiElementRoutes from './UiElements'
import ExtensionsRoutes from './Extensions'
import PageLayoutsRoutes from './PageLayouts'
import TransactionsRoutes from "./Transactions"
import SitesRoutes from "./Sites"
import NotificationsRoutes from "./Notifications"
import ReportsRoutes from "./Reports"
import AccountRoutes from "./Account"
import PaymentForm from "./PaymentForm"

// ** Document title
const TemplateTitle = '%s - Fire Pay Form'

// ** Default Route
const DefaultRoute = '/'

// ** Merge Routes
const Routes = [
  ...PaymentForm
  //...TransactionsRoutes,
  //...SitesRoutes,
  //...NotificationsRoutes,
  //...ReportsRoutes,
  //...AccountRoutes,
  //...DashboardRoutes,
  //...AppRoutes,
  //...PagesRoutes,
  //...UiElementRoutes,
  //...ExtensionsRoutes,
  //...PageLayoutsRoutes,
  //...FormRoutes,
  //...TablesRoutes,
  //...ChartsRoutes
]

export { DefaultRoute, TemplateTitle, Routes }
